export const setBlocStatus = (indexSetting, order, status) => ({
  type: "SET_BLOC_STATUS",
  indexSetting,
  order,
  status
});

export const setBlocsOrder = (oldIndex, newIndex, indexSetting) => ({
  type: "SET_BLOCS_ORDER",
  oldIndex,
  newIndex,
  indexSetting
});

export const setBlocDisposition = (order, disposition) => ({
  type: "SET_BLOC_DISPOSITION",
  order,
  disposition
});

export const setBlocTitle = (indexSetting, order, lng, value) => ({
  type: "SET_BLOC_TITLE",
  indexSetting,
  order,
  lng,
  value
});

export const setBlocSubtitle = (indexSetting, order, lng, value) => ({
  type: "SET_BLOC_SUBTITLE",
  indexSetting,
  order,
  lng,
  value
});

export const setBlocLabel = (indexSetting, order, value) => ({
  type: "SET_BLOC_LABEL",
  indexSetting,
  order,
  value
});

export const setBlocUrl = (index, order, value) => ({
  type: "SET_BLOC_URL",
  index,
  order,
  value
});

export const setBlocIcon = (index, order, value) => ({
  type: "SET_BLOC_ICON",
  index,
  order,
  value
});

export const setBlocApp = (index, order, value) => ({
  type: "SET_BLOC_APP",
  index,
  order,
  value
});

export const saveBloc = resp => ({
  type: "SAVE_BLOC",
  payload: resp
});

export const setHubBlocs = blocs => ({
  type: "SET_HUB_BLOCS",
  blocs
});

export const addNewBloc = () => ({
  type: "ADD_NEW_BLOC"
});

export const deleteBloc = (index, order) => ({
  type: "DELETE_BLOC",
  order,
  index
});

export const addNewDrawer = index => ({
  type: "ADD_NEW_DRAWER",
  index
});

export const addCondition = (order, condition) => ({
  type: "ADD_CONDITION",
  order,
  condition
});

export const setScope = (scope, index) => ({
  type: "SET_SCOPE",
  scope,
  index
});

export const setGroup = (group, index) => ({
  type: "SET_GROUP",
  group,
  index
});

export const setWidgets = (widgets, index) => ({
  type: "SET_WIDGETS",
  widgets,
  index
});

export const setApps = (apps, index) => ({
  type: "SET_APPS",
  apps,
  index
});

export const deleteSetting = index => ({
  type: "DELETE_SETTING",
  index
});

export const setLayoutName = (name, index) => ({
  type: "SET_LAYOUT_NAME",
  name,
  index
});



// WEBPACK FOOTER //
// ./src/actions/actions/hub.js